export const apiColumnMap = (apiColumn) => ({
  field: apiColumn.Property,
  filter: { value: apiColumn.Filter?.Value, operation: apiColumn.Filter?.Operation },
  sorting: { priority: apiColumn.Sorting?.Priority, direction: apiColumn.Sorting?.Direction },
  grouping: apiColumn.Grouping,
  id: apiColumn.Id,
})
